import BaseModel from "./BaseModels/BaseModel"
import HostingsiteBase from "./Hostingsite"


export class Subnet extends BaseModel {
  subnet?: string
  hosting_site?: HostingsiteBase
}